// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  background: #fff;
}

.visibility-modal {
  text-align: center;
  color: #3a3a3a;
}

.icon {
  padding-top: 16px;
  line-height: 1;
}
.icon ion-icon {
  font-size: 28px;
  color: #ed143d;
}

h2 {
  margin: 10px 20px 6px;
  font-size: 18px;
  font-weight: 700;
  color: #1b171b;
}

p {
  margin: 0 24px 16px;
  font-size: 15px;
  line-height: 1.35;
  color: #666;
}

.actions {
  display: flex;
  border-top: 1px solid #e4e4e4;
}

button {
  flex: 1;
  margin: 0;
  padding: 14px 8px 15px;
  border: 0;
  background: transparent;
  color: #3a3a3a;
  font-size: 17px;
  font-family: inherit;
  cursor: pointer;
}
button + button {
  border-left: 1px solid #e4e4e4;
}
button:active {
  background: rgba(0, 0, 0, 0.04);
}`, "",{"version":3,"sources":["webpack://./src/app/modals/booking-visibility-modal/booking-visibility-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;AACF;AACE;EACE,eAAA;EACA,cAAA;AACJ;;AAGA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAAF;;AAGA;EACE,aAAA;EACA,6BAAA;AAAF;;AAGA;EACE,OAAA;EACA,SAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;AAAF;AAEE;EACE,8BAAA;AAAJ;AAGE;EACE,+BAAA;AADJ","sourcesContent":[":host {\n  display: block;\n  background: #fff;\n}\n\n.visibility-modal {\n  text-align: center;\n  color: #3a3a3a;\n}\n\n.icon {\n  padding-top: 16px;\n  line-height: 1;\n\n  ion-icon {\n    font-size: 28px;\n    color: #ed143d;\n  }\n}\n\nh2 {\n  margin: 10px 20px 6px;\n  font-size: 18px;\n  font-weight: 700;\n  color: #1b171b;\n}\n\np {\n  margin: 0 24px 16px;\n  font-size: 15px;\n  line-height: 1.35;\n  color: #666;\n}\n\n.actions {\n  display: flex;\n  border-top: 1px solid #e4e4e4;\n}\n\nbutton {\n  flex: 1;\n  margin: 0;\n  padding: 14px 8px 15px;\n  border: 0;\n  background: transparent;\n  color: #3a3a3a;\n  font-size: 17px;\n  font-family: inherit;\n  cursor: pointer;\n\n  & + button {\n    border-left: 1px solid #e4e4e4;\n  }\n\n  &:active {\n    background: rgba(0, 0, 0, 0.04);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
